import DomPurify from "isomorphic-dompurify";
import MaxWidthWrapper from "components/Tiles/commonComponents/MaxWidthWrapper";
import FaqDisplayItem from "./FaqDisplayItem";

type FaqDisplayProps = {
  bgColor?: string;
  title?: string;
  content?: string;
  sections: {
    question: string;
    answer: string;
  }[];
  titleTag?: React.ElementType;
  expandAll?: boolean; // New optional prop
};

const FaqDisplay = ({
  bgColor,
  title,
  content,
  sections,
  titleTag = "p",
  expandAll // No default value, so it's undefined if not provided
}: FaqDisplayProps) => {
  const TitleTag = titleTag;

  return (
    <div
      id="faq-display-59"
      style={{
        backgroundColor: bgColor
      }}
    >
      <MaxWidthWrapper>
        <div className="tile-container py-24 lg:grid lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="mb-8 @3xl:mb-0">
              <TitleTag
                className="mb-3 font-heading text-4xl text-primary-700 lg:text-4xl"
                dangerouslySetInnerHTML={{ __html: DomPurify.sanitize(title || "") }}
              />
              {content && <p className="text-lg text-primary-700 @3xl:text-xl">{content}</p>}
            </div>
          </div>
          <div className="mt-10 lg:col-span-7 lg:mt-0">
            {sections?.map((section) => (
              <FaqDisplayItem
                section={section}
                key={section.question}
                defaultExpanded={expandAll} // Pass expandAll directly, it will be undefined if not provided
              />
            ))}
          </div>
        </div>
      </MaxWidthWrapper>
    </div>
  );
};

export default FaqDisplay;
